import { spacing } from './spacing';
const PAGE_LAYOUT_CONTROL_HEIGHT = spacing._144;

const PAGE_LAYOUT_CONTENT_HEADER_HEIGHT = spacing._89;

const TOP_BAR_HEIGHT = spacing._89;

export {
  PAGE_LAYOUT_CONTENT_HEADER_HEIGHT,
  PAGE_LAYOUT_CONTROL_HEIGHT,
  TOP_BAR_HEIGHT,
};
